// extracted by mini-css-extract-plugin
module.exports = {"postInput":"PostInput_postInput__4DlUQ"};